const INTL_FLAG_CODES = [
  { value: '213', text: 'Algeria (213)', countryCode: 'dz' },
  { value: '1684', text: 'American Samoa (1684)', countryCode: 'as' },
  { value: '376', text: 'Andorra (376)', countryCode: 'ad' },
  { value: '244', text: 'Angola (244)', countryCode: 'ao' },
  { value: '1264', text: 'Anguilla (1264)', countryCode: 'ai' },
  { value: '672', text: 'Antarctica/Norfolk Island (672)', countryCode: 'nf' },
  { value: '1268', text: 'Antigua And Barbuda (1268)', countryCode: 'ag' },
  { value: '54', text: 'Argentina (54)', countryCode: 'ar' },
  { value: '355', text: 'Armenia (355)', countryCode: 'am' },
  { value: '297', text: 'Aruba (297)', countryCode: 'aw' },
  { value: '61', text: 'Australia/Cocos/Christmas Islands (61)', countryCode: 'au' },
  { value: '43', text: 'Austria (43)', countryCode: 'at' },
  { value: '994', text: 'Azerbaijan (994)', countryCode: 'az' },
  { value: '973', text: 'Bahrain (973)', countryCode: 'bh' },
  { value: '880', text: 'Bangladesh (880)', countryCode: 'bd' },
  { value: '1246', text: 'Barbados (1246)', countryCode: 'bb' },
  { value: '375', text: 'Belarus (375)', countryCode: 'by' },
  { value: '32', text: 'Belgium (32)', countryCode: 'be' },
  { value: '501', text: 'Belize (501)', countryCode: 'bz' },
  { value: '229', text: 'Benin (229)', countryCode: 'bj' },
  { value: '1441', text: 'Bermuda (1441)', countryCode: 'bm' },
  { value: '975', text: 'Bhutan (975)', countryCode: 'bt' },
  { value: '591', text: 'Bolivia (591)', countryCode: 'bo' },
  { value: '387', text: 'Bosnia And Herzegowina (387)', countryCode: 'ba' },
  { value: '267', text: 'Botswana (267)', countryCode: 'bw' },
  { value: '55', text: 'Brazil (55)', countryCode: 'br' },
  { value: '673', text: 'Brunei Darussalam (673)', countryCode: 'bn' },
  { value: '359', text: 'Bulgaria (359)', countryCode: 'bg' },
  { value: '226', text: 'Burkina Faso (226)', countryCode: 'bf' },
  { value: '257', text: 'Burundi (257)', countryCode: 'bi' },
  { value: '855', text: 'Cambodia (855)', countryCode: 'kh' },
  { value: '237', text: 'Cameroon (237)', countryCode: 'cm' },
  { value: '1', text: 'Canada (1)', countryCode: 'ca' },
  { value: '1345', text: 'Cayman Islands (1345)', countryCode: 'ky' },
  { value: '236', text: 'Central African Republic (236)', countryCode: 'cf' },
  { value: '235', text: 'Chad (235)', countryCode: 'td' },
  { value: '56', text: 'Chile (56)', countryCode: 'cl' },
  { value: '86', text: 'China (86)', countryCode: 'cn' },
  { value: '61', text: 'Christmas Islands (61)', countryCode: 'cx' },
  { value: '61', text: 'Cocos (61)', countryCode: 'cc' },
  { value: '57', text: 'Colombia (57)', countryCode: 'co' },
  { value: '269', text: 'Comoros (269)', countryCode: 'km' },
  { value: '243', text: 'Congo, Democratic Republic Of (243)', countryCode: 'cd' },
  { value: '242', text: 'Congo, Peoples Republic Of (242)', countryCode: 'cg' },
  { value: '682', text: 'Cook Islands (682)', countryCode: 'ck' },
  { value: '506', text: 'Costa Rica (506)', countryCode: 'cr' },
  { value: '225', text: 'Cote DIvoire (225)', countryCode: 'ci' },
  { value: '385', text: 'Croatia (385)', countryCode: 'hr' },
  { value: '53', text: 'Cuba (53)', countryCode: 'cu' },
  { value: '357', text: 'Cyprus (357)', countryCode: 'cy' },
  { value: '420', text: 'Czech Republic (420)', countryCode: 'cz' },
  { value: '45', text: 'Denmark (45)', countryCode: 'dk' },
  { value: '253', text: 'Djibouti (253)', countryCode: 'dj' },
  { value: '1767', text: 'Dominica (1767)', countryCode: 'dm' },
  { value: '1809', text: 'Dominican Republic (1809)', countryCode: 'do' },
  { value: '670', text: 'East Timor/Timor-Leste (670)', countryCode: 'tl' },
  { value: '593', text: 'Ecuador (593)', countryCode: 'ec' },
  { value: '20', text: 'Egypt (20)', countryCode: 'eg' },
  { value: '503', text: 'El Salvador (503)', countryCode: 'sv' },
  { value: '240', text: 'Equatorial Guinea (240)', countryCode: 'gq' },
  { value: '372', text: 'Estonia (372)', countryCode: 'ee' },
  { value: '251', text: 'Ethiopia (251)', countryCode: 'et' },
  { value: '500', text: 'Falkland Islands (Malvinas) (500)', countryCode: 'fk' },
  { value: '298', text: 'Faroe Islands (298)', countryCode: 'fo' },
  { value: '679', text: 'Fiji (679)', countryCode: 'fj' },
  { value: '358', text: 'Finland (358)', countryCode: 'fi' },
  { value: '33', text: 'France (33)', countryCode: 'fr' },
  { value: '594', text: 'French Guiana (594)', countryCode: 'gf' },
  { value: '689', text: 'French Polynesia (689)', countryCode: 'pf' },
  { value: '241', text: 'Gabon (241)', countryCode: 'ga' },
  { value: '220', text: 'Gambia (220)', countryCode: 'gm' },
  { value: '995', text: 'Georgia (995)', countryCode: 'ge' },
  { value: '49', text: 'Germany (49)', countryCode: 'de' },
  { value: '233', text: 'Ghana (233)', countryCode: 'gh' },
  { value: '350', text: 'Gibraltar (350)', countryCode: 'gi' },
  { value: '30', text: 'Greece (30)', countryCode: 'gr' },
  { value: '299', text: 'Greenland (299)', countryCode: 'gl' },
  { value: '1473', text: 'Grenada (1473)', countryCode: 'gd' },
  { value: '590', text: 'Guadeloupe/Saint Barthelemy (590)', countryCode: 'gp' },
  { value: '1671', text: 'Guam (1671)', countryCode: 'gu' },
  { value: '502', text: 'Guatemala (502)', countryCode: 'gt' },
  { value: '224', text: 'Guinea (224)', countryCode: 'gn' },
  { value: '245', text: 'Guinea-Bissau (245)', countryCode: 'gw' },
  { value: '592', text: 'Guyana (592)', countryCode: 'gy' },
  { value: '509', text: 'Haiti (509)', countryCode: 'ht' },
  { value: '504', text: 'Honduras (504)', countryCode: 'hn' },
  { value: '852', text: 'Hong Kong (852)', countryCode: 'hk' },
  { value: '36', text: 'Hungary (36)', countryCode: 'hu' },
  { value: '354', text: 'Iceland (354)', countryCode: 'is' },
  { value: '91', text: 'India (91)', countryCode: 'in' },
  { value: '62', text: 'Indonesia (62)', countryCode: 'id' },
  { value: '98', text: 'Iran (98)', countryCode: 'ir' },
  { value: '964', text: 'Iraq (964)', countryCode: 'iq' },
  { value: '353', text: 'Ireland (353)', countryCode: 'ie' },
  { value: '972', text: 'Israel (972)', countryCode: 'il' },
  { value: '39', text: 'Italy (39)', countryCode: 'it' },
  { value: '1876', text: 'Jamaica (1876)', countryCode: 'jm' },
  { value: '81', text: 'Japan (81)', countryCode: 'jp' },
  { value: '962', text: 'Jordan (962)', countryCode: 'jo' },
  { value: '7', text: 'Kazakhstan (7)', countryCode: 'kz' },
  { value: '254', text: 'Kenya (254)', countryCode: 'ke' },
  { value: '686', text: 'Kiribati (686)', countryCode: 'ki' },
  { value: '850', text: 'Korea, North (850)', countryCode: 'kp' },
  { value: '82', text: 'South Korea (82)', countryCode: 'kr' },
  { value: '965', text: 'Kuwait (965)', countryCode: 'kw' },
  { value: '996', text: 'Kyrgyzstan (996)', countryCode: 'kg' },
  { value: '856', text: 'Laos (856)', countryCode: 'la' },
  { value: '371', text: 'Latvia (371)', countryCode: 'lv' },
  { value: '961', text: 'Lebanon (961)', countryCode: 'lb' },
  { value: '266', text: 'Lesotho (266)', countryCode: 'ls' },
  { value: '231', text: 'Liberia (231)', countryCode: 'lr' },
  { value: '218', text: 'Libyan Arab Jamahiriya (218)', countryCode: 'ly' },
  { value: '423', text: 'Liechtenstein (423)', countryCode: 'li' },
  { value: '370', text: 'Lithuania (370)', countryCode: 'lt' },
  { value: '352', text: 'Luxembourg (352)', countryCode: 'lu' },
  { value: '853', text: 'Macao (853)', countryCode: 'mo' },
  { value: '389', text: 'Macedonia (389)', countryCode: 'mk' },
  { value: '261', text: 'Madagascar (261)', countryCode: 'mg' },
  { value: '265', text: 'Malawi (265)', countryCode: 'mw' },
  { value: '60', text: 'Malaysia (60)', countryCode: 'my' },
  { value: '960', text: 'Maldives (960)', countryCode: 'mv' },
  { value: '223', text: 'Mali (223)', countryCode: 'ml' },
  { value: '356', text: 'Malta (356)', countryCode: 'mt' },
  { value: '692', text: 'Marshall Islands (692)', countryCode: 'mh' },
  { value: '596', text: 'Martinique (596)', countryCode: 'mq' },
  { value: '222', text: 'Mauritania (222)', countryCode: 'mr' },
  { value: '230', text: 'Mauritius (230)', countryCode: 'mu' },
  { value: '262', text: 'Mayotte Islands (262)', countryCode: 'yt' },
  { value: '52', text: 'Mexico (52)', countryCode: 'mx' },
  { value: '691', text: 'Micronesia (691)', countryCode: 'fm' },
  { value: '373', text: 'Moldova (373)', countryCode: 'md' },
  { value: '377', text: 'Monaco (377)', countryCode: 'mc' },
  { value: '976', text: 'Mongolia (976)', countryCode: 'mn' },
  { value: '382', text: 'Montenegro (382)', countryCode: 'me' },
  { value: '664', text: 'Montserrat (664)', countryCode: 'ms' },
  { value: '212', text: 'Morocco (212)', countryCode: 'ma' },
  { value: '258', text: 'Mozambique (258)', countryCode: 'mz' },
  { value: '95', text: 'Myanmar (95)', countryCode: 'mm' },
  { value: '264', text: 'Namibia (264)', countryCode: 'na' },
  { value: '674', text: 'Nauru (674)', countryCode: 'nr' },
  { value: '977', text: 'Nepal (977)', countryCode: 'np' },
  { value: '31', text: 'Netherlands (31)', countryCode: 'nl' },
  { value: '687', text: 'New Caledonia (687)', countryCode: 'nc' },
  { value: '64', text: 'New Zealand (64)', countryCode: 'nz' },
  { value: '505', text: 'Nicaragua (505)', countryCode: 'ni' },
  { value: '227', text: 'Niger (227)', countryCode: 'ne' },
  { value: '234', text: 'Nigeria (234)', countryCode: 'ng' },
  { value: '683', text: 'Niue (683)', countryCode: 'nu' },
  { value: '47', text: 'Norway (47)', countryCode: 'no' },
  { value: '968', text: 'Oman (968)', countryCode: 'om' },
  { value: '92', text: 'Pakistan (92)', countryCode: 'pk' },
  { value: '680', text: 'Palau (680)', countryCode: 'pw' },
  { value: '507', text: 'Panama (507)', countryCode: 'pa' },
  { value: '675', text: 'Papua New Guinea (675)', countryCode: 'pg' },
  { value: '595', text: 'Paraguay (595)', countryCode: 'py' },
  { value: '51', text: 'Peru (51)', countryCode: 'pe' },
  { value: '63', text: 'Philippines (63)', countryCode: 'ph' },
  { value: '48', text: 'Poland (48)', countryCode: 'pl' },
  { value: '351', text: 'Portugal (351)', countryCode: 'pt' },
  { value: '974', text: 'Qatar (974)', countryCode: 'qa' },
  { value: '40', text: 'Romania (40)', countryCode: 'ro' },
  { value: '7', text: 'Russia (7)', countryCode: 'ru' },
  { value: '250', text: 'Rwanda (250)', countryCode: 'rw' },
  { value: '1869', text: 'Saint Kitts And Nevis (1869)', countryCode: 'kn' },
  { value: '1758', text: 'Saint Lucia (1758)', countryCode: 'lc' },
  { value: '1784', text: 'Saint Vincent And The Grenadines (1784)', countryCode: 'vc' },
  { value: '685', text: 'Samoa (685)', countryCode: 'ws' },
  { value: '378', text: 'San Marino (378)', countryCode: 'sm' },
  { value: '239', text: 'Sao Tome And Principe (239)', countryCode: 'st' },
  { value: '966', text: 'Saudi Arabia (966)', countryCode: 'sa' },
  { value: '221', text: 'Senegal (221)', countryCode: 'sn' },
  { value: '381', text: 'Serbia/Yugoslavia (381)', countryCode: 'cs' },
  { value: '232', text: 'Sierra Leone (232)', countryCode: 'sl' },
  { value: '65', text: 'Singapore (65)', countryCode: 'sg' },
  { value: '421', text: 'Slovakia (Slovak Republic) (421)', countryCode: 'sk' },
  { value: '386', text: 'Slovenia (386)', countryCode: 'si' },
  { value: '677', text: 'Solomon Islands (677)', countryCode: 'sb' },
  { value: '252', text: 'Somalia (252)', countryCode: 'so' },
  { value: '27', text: 'South Africa (27)', countryCode: 'za' },
  { value: '34', text: 'Spain (34)', countryCode: 'es' },
  { value: '94', text: 'Sri Lanka (94)', countryCode: 'lk' },
  { value: '290', text: 'St. Helena (290)', countryCode: 'sh' },
  { value: '508', text: 'St. Pierre And Miquelon (508)', countryCode: 'pm' },
  { value: '249', text: 'Sudan (249)', countryCode: 'sd' },
  { value: '597', text: 'Suritext (597)', countryCode: 'sr' },
  { value: '268', text: 'Swaziland (268)', countryCode: 'sz' },
  { value: '46', text: 'Sweden (46)', countryCode: 'se' },
  { value: '41', text: 'Switzerland (41)', countryCode: 'ch' },
  { value: '963', text: 'Syrian Arab Republic (963)', countryCode: 'sy' },
  { value: '886', text: 'Taiwan (886)', countryCode: 'tw' },
  { value: '992', text: 'Tajikistan (992)', countryCode: 'tj' },
  { value: '255', text: 'Tanzania, United Republic Of (255)', countryCode: 'tz' },
  { value: '66', text: 'Thailand (66)', countryCode: 'th' },
  { value: '228', text: 'Togo (228)', countryCode: 'tg' },
  { value: '676', text: 'Tonga (676)', countryCode: 'to' },
  { value: '1868', text: 'Trinidad And Tobago (1868)', countryCode: 'tt' },
  { value: '216', text: 'Tunisia (216)', countryCode: 'tn' },
  { value: '90', text: 'Turkey (90)', countryCode: 'tr' },
  { value: '993', text: 'Turkmenistan (993)', countryCode: 'tm' },
  { value: '1649', text: 'Turks And Caicos Islands (1649)', countryCode: 'tc' },
  { value: '688', text: 'Tuvalu (688)', countryCode: 'tv' },
  { value: '256', text: 'Uganda (256)', countryCode: 'ug' },
  { value: '380', text: 'Ukraine (380)', countryCode: 'ua' },
  { value: '971', text: 'United Arab Emirates (971)', countryCode: 'ae' },
  { value: '44', text: 'United Kingdom (44)', countryCode: 'gb' },
  { value: '1', text: 'United States (1)', countryCode: 'us' },
  { value: '598', text: 'Uruguay (598)', countryCode: 'uy' },
  { value: '998', text: 'Uzbekistan (998)', countryCode: 'uz' },
  { value: '678', text: 'Vanuatu (678)', countryCode: 'vu' },
  { value: '58', text: 'Venezuela (58)', countryCode: 've' },
  { value: '84', text: 'Vietnam (84)', countryCode: 'vn' },
  { value: '1284', text: 'Virgin Islands (British) (1284)', countryCode: 'vg' },
  { value: '1340', text: 'Virgin Islands (U.S) (1340)', countryCode: 'vi' },
  { value: '681', text: 'Wallis And Futuna Islands  (681)', countryCode: 'wf' },
  { value: '967', text: 'Yemen (967)', countryCode: 'ye' },
  { value: '260', text: 'Zambia (260)', countryCode: 'zm' },
  { value: '263', text: 'Zimbabwe (263)', countryCode: 'zw' },
  { value: 'other', text: 'Other' },
];

export default INTL_FLAG_CODES;



// WEBPACK FOOTER //
// ./src/constants/intlFlagCodes.js